import useParticipantsWithHost from './useParticipantsWithHost';
import useWSTurnState from './useWSTurnState';

/**
 * Hook para gerenciar a lógica dos participantes na frase
 * @returns {Object} Objeto com participantes ordenados e dados relacionados
 */
export const usePhraseParticipants = () => {
  const { participantA, participantB, participantMod } = useParticipantsWithHost();
  const { lastCompleter } = useWSTurnState();

  // O lastCompleter é o "first" (quem completa primeiro)
  // Se lastCompleter é "A", então A é first e B é second
  // Se lastCompleter é "B", então B é first e A é second
  const [first, second] = lastCompleter === "A"
    ? [participantA, participantB]
    : [participantB, participantA];

  return {
    first,
    second,
    participantMod,
    lastCompleter
  };
};
